import { useState, useEffect, type PropsWithChildren } from 'react';

import {
  rememberScrollPosition,
  resetScrollPosition,
} from '../01-core/Utilities';
import { MegaMenuContext } from './MegaMenuContext';

export const MegaMenuProvider = ({ children }: PropsWithChildren) => {
  const [open, setOpen] = useState<string | null>(null);

  const doOpen = (id: string) => {
    const body = document?.body;
    if (!open && body) {
      rememberScrollPosition();
    }
    setOpen(id);
  };

  const doClose = () => {
    setOpen(null);
  };

  useEffect(() => {
    const body = document.body;
    if (open) {
      body.classList.add('mega-menu-open');
    } else {
      body.classList.remove('mega-menu-open');
      resetScrollPosition();
    }

    return () => {
      if (open) {
        const body = document.body;
        body.classList.remove('mega-menu-open');
        resetScrollPosition();
      }
    };
  }, [open]);

  return (
    <MegaMenuContext.Provider value={[open, doOpen, doClose]}>
      {children}
    </MegaMenuContext.Provider>
  );
};
